import { useNavigate } from 'react-router-dom';

import downloadTop from '@/assets/download/download_top.webp';
import Button from '@/components/button';
import BlurryLoadingImage from '@/components/progressive-img';
import RecommendGames from '@/modules/RecommendGames';

import styles from './styles.module.less';

const VipModal = () => {
  const navigate = useNavigate();

  const goVip = () => {
    navigate('/recharge');
  };

  return (
    <div className={styles.box}>
      <div className={styles.container}>
        <div className={styles.main}>
          <BlurryLoadingImage loading="lazy" src={downloadTop} className={styles.imgTop} alt="" />
          <div className={styles.content}>
            <div>Recargue para convertirse en VIP y desbloquear más juegos, y aproveche beneficios como retiradas.</div>
          </div>
          <div className={styles.action}>
            <Button type="success" style={{ width: '100%' }} onClick={goVip}>
              Conviértase en VIP
            </Button>
          </div>
        </div>
        <RecommendGames />
      </div>
    </div>
  );
};
export default VipModal;
